import { __extends } from "tslib";
import { EventBase } from '@awayjs/core';
var StyleEvent = /** @class */ (function (_super) {
    __extends(StyleEvent, _super);
    function StyleEvent(type, style) {
        var _this = _super.call(this, type) || this;
        _this._style = style;
        return _this;
    }
    Object.defineProperty(StyleEvent.prototype, "style", {
        get: function () {
            return this._style;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Clones the event.
     * @return An exact duplicate of the current object.
     */
    StyleEvent.prototype.clone = function () {
        return new StyleEvent(this.type, this._style);
    };
    /**
     *
     */
    StyleEvent.INVALIDATE_PROPERTIES = 'invalidateProperties';
    return StyleEvent;
}(EventBase));
export { StyleEvent };
